import { useNode } from "@craftjs/core";
import React, { useContext } from "react";
import { PostAuthorSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraPreviewContext } from "../../post-preview/context";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { GrigoraEditorContext } from "../../editor/context";
import { AccountContext } from "../../account/account";

export const PostAuthor = (props) => {
  const previewContext = useContext(GrigoraPreviewContext);
  const { project, getImgSrcUrl, cmsPosts, projectMembers } =
    useContext(GrigoraDashboardContext) ?? {};

  const { userAttributes } = useContext(AccountContext) ?? {};
  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  var {
    authorName = "Post Author",
    authorBio = "This is the bio of post author.",
    structureTag = "h2",
    showName = true,
    showBio = true,
    showAvatar = true,
    link,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-post-author": true,
      [`post-author-${id}`]: id,
    },
    blockProps.className,
  );

  let authorImage;
  if (previewContext?.postData?.author) {
    authorName = projectMembers?.[previewContext?.postData?.author]?.name;
    authorBio = projectMembers?.[previewContext?.postData?.author]?.bio;
  } else if (cmsPosts?.[0]?.author) {
    if (userAttributes?.sub === cmsPosts?.[0]?.author) {
      authorName = userAttributes?.name;
      authorImage = getImgSrcUrl(
        projectMembers[userAttributes?.sub]?.avatar?.src,
        projectMembers[userAttributes?.sub]?.avatar?.srcMode,
      );
    }
  }

  if (!authorName) {
    authorName = "Author Name";
  }

  if (!authorBio) {
    authorBio = "Author Bio";
  }

  var Tag = structureTag;

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__PostAuthor(id, props)}`}</style>
      {link ? (
        <a
          onClick={(e) => {
            e.preventDefault();
          }}
          className="post-author-link"
          href={link}
        >
          <div className="post-author-container">
            {showAvatar && (
              <div className="post-author-image">
                <img
                  src={
                    authorImage ??
                    "https://secure.gravatar.com/avatar/314f4b6b87b39cf6bc44e7c209042387?s=96&d=mm&r=g"
                  }
                />
              </div>
            )}

            <div className="post-author-details">
              {showName && <Tag>{authorName}</Tag>}
              {showBio && <span>{authorBio}</span>}
            </div>
          </div>
        </a>
      ) : (
        <div className="post-author-container">
          {showAvatar && (
            <div className="post-author-image">
              <img
                src={
                  authorImage ??
                  "https://secure.gravatar.com/avatar/314f4b6b87b39cf6bc44e7c209042387?s=96&d=mm&r=g"
                }
              />
            </div>
          )}

          <div className="post-author-details">
            {showName && <Tag>{authorName}</Tag>}
            {showBio && <span>{authorBio}</span>}
          </div>
        </div>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
PostAuthor.displayName = "PostAuthor";

PostAuthor.craft = {
  name: "Post Author",
  props: {},
  related: {
    settings: PostAuthorSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "cms",
  },
  custom: {
    name: "Post Author",
    slug: "grigora/post-author",
  },
};
